export default {
  base_url: "http://chunab.pahilopost.com",
  // api_base_url: "http://localhost:8080",
  api_base_url: "http://viz.vantagebit.com",
  // ws_url: 'localhost:8080',
  ws_url: 'viz.vantagebit.com',
  cdn_url: 'http://djuqgb0zu1nm2.cloudfront.net'
}


// WEBPACK FOOTER //
// ./src/config.js